<template>
  <div class="root">
    <div class="title bg-purple">签收情况</div>
    <el-form class="form" size="mini" label-position="left" label-width="100px">
      <el-form-item label="签收时间">{{signFor.signForTime}}</el-form-item>
      <el-form-item label="签收情况">{{signFor.signForSituation}}</el-form-item>
      <el-form-item label="签收人">{{signFor.signForName}}</el-form-item>
      <el-form-item label="收货人电话">{{signFor.phone}}</el-form-item>
      <el-form-item label="收货人身份证">{{signFor.idNumber}}</el-form-item>
      <el-form-item label="代理人身份证">{{signFor.agentIdNumber}}</el-form-item>
      <el-form-item label="出库人">{{''}}</el-form-item>
      <el-form-item label="签收操作人">{{signFor.createUserName}}</el-form-item>
      <el-form-item label="签收备注">{{signFor.remarks}}</el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      signFor: {
        signForTime: "",
        signForSituation: "",
        signForName: "",
        phone: "",
        idNumber: "",
        agentIdNumber: "",
        createUserName: "",
        remarks: ""
      },
    };
  },
  watch: {
    waybillSplitId(val) {
      if (!val) {
        return;
      }
      this.getData();
    },
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData() {
      if(!this.waybillSplitId){
                return
      }
      const res = await this.$API.runDetail({
        number: "admin_waybill_sum_all_sign_info_v5",
        waybillSplitId: this.waybillSplitId,
      });
      this.signFor = res;
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  width: 100%;
  height: 100%;
  .title {
    display: flex;
    justify-content: center;
    height: 35px;
    line-height: 35px;
  }
  .el-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>